import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { MenuFilters, StoreMenu } from './menuSliceTypes';

export interface MenuState {
  selectedMenu: StoreMenu | null;
  selectedMenuName: string | '';
  selectedMenuCategories: any;
  selectedMenuItems: any;
  selectedMenuId: number | null;
  categoryId: number | null;
  currentSelectedItem?: any;
  menuFilters: MenuFilters;
  menuSearchVal: string;
  priceLimits: {
    minPrice: number;
    maxPrice: number;
    categoryId?: number;
  };
  allergensModal: { open: boolean; allergensList: number[] };
}

export const initialMenuFilters: MenuFilters = {
  allergens: [],
  tags: [],
  filterPopup: false,
  cookingTime: {
    value: '',
  },
  filterPrice: [-1, -1],
};

const initialState: MenuState = {
  selectedMenu: null,
  selectedMenuName: '',
  selectedMenuId: null,
  selectedMenuCategories: [],
  selectedMenuItems: [],
  categoryId: null,
  currentSelectedItem: null,
  menuFilters: initialMenuFilters,
  menuSearchVal: '',
  priceLimits: {
    minPrice: -1,
    maxPrice: -1,
  },
  allergensModal: { open: false, allergensList: [] },
};

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setSelectedMenu: (state, action: PayloadAction<any>) => {
      state.selectedMenu = action.payload.menu;
      state.selectedMenuName = action.payload.name;
      state.selectedMenuId = action.payload.id;
    },
    resetSelectedMenuDetails: (state, action: PayloadAction<any>) => {
      state.selectedMenu = initialState.selectedMenu;
      state.selectedMenuName = initialState.selectedMenuName;
      state.selectedMenuId = initialState.selectedMenuId;
    },
    setCategory: (state, action: PayloadAction<any>) => {
      state.categoryId = action.payload.categoryId;
    },
    setCurrentSelectedItem: (state, action: PayloadAction<any>) => {
      state.currentSelectedItem = action.payload;
    },
    setMenuFilters: (state, action: PayloadAction<MenuFilters>) => {
      state.menuFilters = action.payload;
    },
    setMenuSearchVal: (state, action: PayloadAction<string>) => {
      state.menuSearchVal = action.payload;
    },
    resetPriceLimits: (state) => {
      state.priceLimits = {
        minPrice: -1,
        maxPrice: -1,
      };
      state.menuFilters.filterPrice = [-1, -1];
    },
    setPriceLimits: (
      state,
      action: PayloadAction<{
        minPrice: number;
        maxPrice: number;
        categoryId?: number;
      }>
    ) => {
      state.priceLimits = {
        minPrice: Math.floor(action.payload.minPrice / 10) * 10,
        maxPrice: Math.ceil(action.payload.maxPrice / 10) * 10,
        categoryId: action.payload.categoryId,
      };
      state.menuFilters.filterPrice = [
        Math.floor(action.payload.minPrice / 10) * 10,
        Math.ceil(action.payload.maxPrice / 10) * 10,
      ];
    },
    setAllergenModal: (state, action: PayloadAction<{ open: boolean; allergensList: number[] }>) => {
      state.allergensModal = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSelectedMenu,
  resetSelectedMenuDetails,
  setCategory,
  setCurrentSelectedItem,
  setMenuFilters,
  setMenuSearchVal,
  setPriceLimits,
  resetPriceLimits,
  setAllergenModal,
} = menuSlice.actions;

export default menuSlice.reducer;
